import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { toast } from 'react-toastify';

import { redirect_URL, sampleRegistrarUID } from '../../config';
export const RegistrarPage: React.FC = (): JSX.Element => {
  const [url, setUrl] = useState('');
  const [domainName, setDomainName] = useState('');

  const search = (e: React.FormEvent) => {
    e.preventDefault();
    if (domainName === '') {
      toast.error('Please Enter Domain Name');
    } else {
      let urlRegistrar = redirect_URL + `/registrar-message?registrarId=${sampleRegistrarUID}&domainName=${domainName}`;
      setUrl(urlRegistrar);
      var iframe: HTMLIFrameElement = document.getElementById('iframe') as HTMLIFrameElement;
      if (iframe) {
        iframe.src = url;
      }
    }
  };
  return (
    <div className="container mt-3">
      <Helmet>
        <title>Saw.com Domain Broker Service For Your Business</title>
      </Helmet>
      <h3>Sample Registrar</h3>
      <form className="input-group mb-3" onSubmit={search}>
        <input type="text" id="domainName" value={domainName} onChange={(e) => setDomainName(e.target.value)} className="form-control" placeholder="Enter the domain name you are looking for" />
        <div className="input-group-append">
          <button className="input-group-text" onSubmit={search}>
            Search
          </button>
        </div>
      </form>
      {url !== '' && <iframe id="iframe" src={url} height="580" width="100%" title="Iframe Example"></iframe>}
    </div>
  );
};
export default RegistrarPage;
